import { company } from '~/company/Company';
import { CONTENT_ID } from '~/pages/Root/constants';

const resetScroll = (options?: ScrollToOptions & { isMobile?: boolean }) => {
  const { isMobile, left = 0, top = 0, behavior } = options || {};

  if (typeof window === 'undefined') {
    return;
  }

  if (company.newDesignSystemEnabled && !isMobile) {
    const contentElement = document.getElementById(CONTENT_ID);

    contentElement?.scrollTo({ left, top, behavior });
    return;
  }

  window.scrollTo({ left, top, behavior });
};

export default resetScroll;
